module.exports = __webpack_public_path__ + "static/media/stevens_logo.5cc025bf.png";